import { Container } from 'pixi.js';
import { TaskToCollectLayout } from '../../../../layouts/common/TaskToCollectLayout';
import { LevelTaskType } from '../../tasks/types';
import { applyLayoutState } from '../../../libs/layouts/populateLayouts/applyLayoutState';

export class TaskToCollectView extends Container {
  private readonly layout = new TaskToCollectLayout();

  constructor(type: LevelTaskType, amount: number) {
    super();
    this.init(type, amount);
  }

  private init(type: LevelTaskType, amount: number): void {
    const { root, goalIcon, amountText } = this.layout;

    root.props({
      parent: this,
    });

    if (amount <= 0) {
      applyLayoutState(this.layout, 'complete');
    } else {
      amountText.text = `${amount}`;
    }

    const textures: Record<LevelTaskType, string> = {
      [LevelTaskType.Hexes]: 'Big_Goal_Icon',
      [LevelTaskType.TapeBlockers]: 'Tape_Blocker_Big_Icon',
      [LevelTaskType.PlankBlockers]: 'Plank_Big_Icon',
      [LevelTaskType.Birds]: 'Bird_Big_Icon',
      [LevelTaskType.Stars]: 'Star_Big_Icon',
      [LevelTaskType.KnotBlockers]: 'Knot_Blocker_Big_Icon',
      [LevelTaskType.Rocket]: 'Rocket_Big_Icon',
      [LevelTaskType.MeasureTape]: 'Measure_Tape_Big_Icon',
      [LevelTaskType.PlankRed]: 'Plank_Big_Icon_Red',
      [LevelTaskType.PlankGreen]: 'Plank_Big_Icon_Green',
      [LevelTaskType.PlankBlue]: 'Plank_Big_Icon_Blue',
      [LevelTaskType.PlankPink]: 'Plank_Big_Icon_Pink',
      [LevelTaskType.PlankYellow]: 'Plank_Big_Icon_Yellow',
      [LevelTaskType.PlankGrey]: 'Plank_Big_Icon_Grey',
      [LevelTaskType.PlankWhite]: 'Plank_Big_Icon_White',
      [LevelTaskType.PlankNavy]: 'Plank_Big_Icon_Navy',
      [LevelTaskType.PlankPurple]: 'Plank_Big_Icon_Purple',
      [LevelTaskType.PlankAny]: 'Plank_Big_Icon_Any',
    };

    goalIcon.props({
      texture: textures[type],
    });
  }
}
